import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

const ContactDrawerSkeleton = ({ classes }) => {
	return (
		<div className={classes.content}>
			<div className={classes.hero}>
				<Skeleton
					animation="wave"
					variant="circle"
					width={56}
					height={56}
					style={{ margin: "0 auto" }}
				/>
				<Skeleton
					animation="wave"
					height={22}
					width={120}
					style={{ margin: "8px auto 0" }}
				/>
				<Skeleton
					animation="wave"
					height={16}
					width={150}
					style={{ margin: "4px auto 0" }}
				/>
			</div>

			{[0, 1].map(section => (
				<div key={section} className={classes.section}>
					<Skeleton animation="wave" height={14} width={90} />
					<Skeleton animation="wave" height={20} width="100%" style={{ marginTop: 10 }} />
					<Skeleton animation="wave" height={20} width="100%" style={{ marginTop: 8 }} />
					<Skeleton animation="wave" height={20} width="80%" style={{ marginTop: 8 }} />
				</div>
			))}
		</div>
	);
};

export default ContactDrawerSkeleton;
